import { RouteName, routes } from '@shared/constants/routes'
import { UngatedHomePage } from '@/features/entrypoint/components/UngatedHomePage'
import { createServerSidePropsHandler } from '@/features/shared/serverUtils/ssrHelpers/createServerSidePropsHandler'
import { fetchCMSDataForSSR } from '@/features/cms/services/CMS/serverUtils'
import {
  getPageRedirect,
  RedirectReason,
} from '@/features/shared/serverUtils/ssrHelpers/redirectReason'
import { withoutHeaderLayout } from '@/features/shared/components/Headers/Layouts/withoutHeaderLayout'
import { INFERRED_ZIP } from '@shared/constants/zip'
import { getSearchQueryString } from '@/features/shared/utils/url'

export const getServerSideProps = createServerSidePropsHandler(
  RouteName.UNGATED_HOMEPAGE,
  async ({ queryClient, ssrContext, authContext }) => {
    const { isAuthenticated, isOnboarded, isGuestUser } = authContext
    if (isAuthenticated) {
      if (!isOnboarded) {
        return getPageRedirect(routes.WELCOME.url, RedirectReason.NOT_ONBOARDED)
      }
      return getPageRedirect(routes.GLOBAL_HOMEPAGE.url, RedirectReason.ALREADY_AUTHENTICATED)
    }

    if (isGuestUser) {
      return getPageRedirect(
        `${routes.GLOBAL_HOMEPAGE.url}${getSearchQueryString(ssrContext.query)}`,
        RedirectReason.NO_GUEST,
      )
    }

    const zip = ssrContext.req.cookies[INFERRED_ZIP]
    const cmsResult = await fetchCMSDataForSSR({ queryClient, ssrContext, authContext }, zip)

    return cmsResult
  },
)

// header and footer controlled via CMS
export default withoutHeaderLayout(UngatedHomePage, { suppressFooter: true })
